import { Box, Button, Stack, Text } from '@stitch-fix/mode-react';
import { useViewEvent, useSelectEvent } from '@stitch-fix/event-reporter';
import { BusinessLine } from '../../types/definitions/vendor/graphql-schema.d';
import styles from './styles.module.scss';
export type PromoCard = {
  id: 'mens_mint_promo_1' | 'mens_mint_promo_2' | 'mens_mint_promo_3' | 'womens_mint_promo_1' | 'womens_mint_promo_2' | 'womens_mint_promo_3';
  name: 'mens_landing_page_promo' | 'womens_landing_page_promo';
  actionName: 'navigate_to_mens_landing_page' | 'navigate_to_womens_landing_page';
  headerText: string;
  bodyText: string;
  link: {
    text: string;
    url: string;
  };
};

// Because our indexes are zero-based, we have to subtract 1 from the index to get the position in the grid
export const PROMO_INDEXES = [4, 15, 27];
export const PROMO_CARD_CONTENT: Record<BusinessLine, PromoCard[]> = {
  MENS: [{
    id: 'mens_mint_promo_1',
    name: 'mens_landing_page_promo',
    actionName: 'navigate_to_mens_landing_page',
    headerText: 'A New Way to Shop',
    bodyText: 'Tell us what you like, we’ll find what you love',
    link: {
      text: 'Learn more',
      url: 'https://www.stitchfix.com/men'
    }
  }, {
    id: 'mens_mint_promo_2',
    name: 'mens_landing_page_promo',
    actionName: 'navigate_to_mens_landing_page',
    headerText: 'Our stylists can help',
    bodyText: "They'll find items that fit your style and body",
    link: {
      text: 'Learn more',
      url: 'https://www.stitchfix.com/men'
    }
  }, {
    id: 'mens_mint_promo_3',
    name: 'mens_landing_page_promo',
    actionName: 'navigate_to_mens_landing_page',
    headerText: 'Discover more looks',
    bodyText: 'Shop complete outfits in your personalized store',
    link: {
      text: 'Learn more',
      url: 'https://www.stitchfix.com/men'
    }
  }],
  WOMENS: [{
    id: 'womens_mint_promo_1',
    name: 'womens_landing_page_promo',
    actionName: 'navigate_to_womens_landing_page',
    headerText: 'A New Way to Shop',
    bodyText: 'Tell us what you like, we’ll find what you love',
    link: {
      text: 'Learn more',
      url: 'https://www.stitchfix.com/women'
    }
  }, {
    id: 'womens_mint_promo_2',
    name: 'womens_landing_page_promo',
    actionName: 'navigate_to_womens_landing_page',
    headerText: 'Our stylists can help',
    bodyText: "They'll find items that fit your style and body",
    link: {
      text: 'Learn more',
      url: 'https://www.stitchfix.com/women'
    }
  }, {
    id: 'womens_mint_promo_3',
    name: 'womens_landing_page_promo',
    actionName: 'navigate_to_womens_landing_page',
    headerText: 'Discover more looks',
    bodyText: 'Shop complete outfits in your personalized store',
    link: {
      text: 'Learn more',
      url: 'https://www.stitchfix.com/women'
    }
  }],
  KIDS: [],
  SHELL: []
};
const PromoCardSmall = ({
  id,
  name,
  actionName,
  headerText,
  bodyText,
  linkText,
  linkUrl
}: {
  id: 'mens_mint_promo_1' | 'mens_mint_promo_2' | 'mens_mint_promo_3' | 'womens_mint_promo_1' | 'womens_mint_promo_2' | 'womens_mint_promo_3';
  name: 'mens_landing_page_promo' | 'womens_landing_page_promo';
  actionName: 'navigate_to_mens_landing_page' | 'navigate_to_womens_landing_page';
  headerText: string;
  bodyText: string;
  linkText: string;
  linkUrl: string;
}) => {
  const {
    ref,
    EventProvider
  } = useViewEvent({
    schema: 'view',
    name,
    content_id: id
  });
  const {
    reportSelectEvent
  } = useSelectEvent();
  return <EventProvider>
      <Box className={styles.PromoCardSmall} ref={ref}>
        <Stack mt={{
        sm: '25%',
        md: '30%',
        lg: '45%'
      }} spacing={0.5}>
          <Text setting="title-medium">{headerText}</Text>
          <Box>
            <Text setting="body-medium" mb={1}>
              {bodyText}
            </Text>
          </Box>
          <Button as="a" variant="filled-staple" width={{
          sm: 'fit',
          md: 'fit',
          lg: 'fixed'
        }} href={linkUrl} onClick={() => reportSelectEvent({
          schema: 'select',
          name,
          action_name: actionName
        })}>
            {linkText}
          </Button>
        </Stack>
      </Box>
    </EventProvider>;
};
export default PromoCardSmall;